import type { ReactNode } from "react";
import { SearchContext } from "@shared-kernel/primary/shared/design-system/shared/search-context";

export const SearchProvider = ({ query, children }: { query: string; children: ReactNode }) => (
  <SearchContext.Provider value={{ query }}>{children}</SearchContext.Provider>
);
